module.exports = __webpack_public_path__ + "static/1seater_4k-d5320ec75735ede6face845d2f99db38.jpg";